interface AeoEnabledSettings {
  enabled?: boolean;
  subscriptionBilling?: { enabled?: boolean } | null;
  freeTrialEndDate?: Date | null;
}

export function isAeoAllowed(
  aeoSettings: AeoEnabledSettings | null | undefined,
): boolean {
  if (!aeoSettings?.enabled) {
    return false;
  }

  const hasBilling = !!aeoSettings.subscriptionBilling?.enabled;

  const inFreeTrial =
    !!aeoSettings.freeTrialEndDate &&
    new Date() < new Date(aeoSettings.freeTrialEndDate);

  return hasBilling || inFreeTrial;
}
